import React from 'react';
import styled from 'styled-components';
import renderNavigationCTAOptions from '../renderNavigationCTAOptions';
import { renderCTAOptions } from '../renderCTAOptions';
import { NavigationBar as NavigationBarProps } from './types/types';

const StyledNavCTA = styled.div`
  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      margin: auto;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }

  a.nav__anchor,
  button.nav__anchor,
  a.szl__link {
    text-decoration: none !important;
    color: ${(props: any) => props.theme.textColor};
    font-size: 0.875rem;

    @media (max-width: 1080px) {
      font-size: 0.75rem;
    }

    &.active,
    &:hover {
      text-decoration: underline;
      color: ${(props: any) => props.theme.linkColor};
    }
  }

  &.cta__container {
    li {
      z-index: 1000;
    }

    @media (max-width: 992px) {
      display: none;
    }
  }
`;

const NavigationBar = ({
  navigationLinks, ctaButtons,
}: NavigationBarProps) => {
  return (
    <StyledNavCTA className="cta__container">
      <ul className="row">
        {navigationLinks?.length !== 0
          && (
            navigationLinks?.map((item, index) => (
              <li key={index}>
                {renderNavigationCTAOptions(item?.sys?.contentType?.sys?.id
                  || item?.contentfuLContentType, item, item?.index)}
              </li>
            ))
          )}
        {ctaButtons?.length !== 0
          && (
            ctaButtons?.map((item, index) => (
              <li key={index}>
                {renderCTAOptions(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item)}
              </li>
            ))
          )}
      </ul>
    </StyledNavCTA>
  );
};

export default NavigationBar;
